import { Link, router } from "@inertiajs/react"
import { LogOut } from "lucide-react"
import type { ReactNode } from "react"
import { Logo } from "@/components/logo"
import { Button } from "@/components/ui/button"
import { useTranslation } from "@/lib/i18n"
import { usePageProps } from "@/lib/use-page-props"

export function AuthenticatedLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation()
  const { auth } = usePageProps()

  return (
    <div className="flex min-h-screen justify-center">
      <div className="flex min-h-screen w-full max-w-[400px] flex-col bg-card print:max-w-none">
        <header className="flex items-center justify-between px-4 pt-5 pb-4 print:hidden">
          <Link href="/" className="flex items-center gap-2" aria-label={t("app.name")}>
            <Logo className="h-7 w-7 text-graphite" />
            <span className="font-display font-bold text-lg text-pine-800">{t("app.name")}</span>
          </Link>
          <div className="flex items-center gap-1">
            {auth.employee && (
              <span className="text-muted-foreground text-sm">{auth.employee.name}</span>
            )}
            <Button
              variant="ghost"
              size="icon"
              aria-label={t("session.logout")}
              onClick={() => router.delete("/logout")}
            >
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </header>
        <div className="hatch h-1.5" />
        <main className="flex flex-1 flex-col">{children}</main>
      </div>
    </div>
  )
}
